import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import reportWebVitals from './reportWebVitals';

import "@fontsource/inter/300.css"; 
import "@fontsource/inter/400.css"; 
import "@fontsource/inter/500.css"; 
import "@fontsource/inter/700.css"; 
import "@fontsource/inter/900.css"; 


import "@fontsource/montserrat/300.css"; 
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css"; 
import "@fontsource/montserrat/600.css"; 
import "@fontsource/montserrat/700.css"; 
import "@fontsource/montserrat/800.css"; 
import "@fontsource/montserrat/900.css"; 


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <GoogleReCaptchaProvider reCaptchaKey="6LcxfIEsAAAAABYkfCl4ntKvkfKCnJyNN87wv-_b">
  <App />
</GoogleReCaptchaProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
